import { render } from "./VaultScreen.vue?vue&type=template&id=3c150df0&scoped=true"
import script from "./VaultScreen.vue?vue&type=script&lang=js"
export * from "./VaultScreen.vue?vue&type=script&lang=js"

import "./VaultScreen.vue?vue&type=style&index=0&id=3c150df0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c150df0"]])

export default __exports__